import { render, staticRenderFns } from "./email_forward_editor.vue?vue&type=template&id=7c863ace&scoped=true&"
import script from "./email_forward_editor.vue?vue&type=script&lang=js&"
export * from "./email_forward_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c863ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c863ace')) {
      api.createRecord('7c863ace', component.options)
    } else {
      api.reload('7c863ace', component.options)
    }
    module.hot.accept("./email_forward_editor.vue?vue&type=template&id=7c863ace&scoped=true&", function () {
      api.rerender('7c863ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/email/forwards/email_forward_editor.vue"
export default component.exports